import type { SVGProps } from 'react'
const SvgDeviceReset = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="device-reset_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#device-reset_svg__a)">
      <path d="M8.991 15.903q-2.65 0-4.617-1.759T2.131 9.75H3.87q.268 1.927 1.72 3.187 1.455 1.26 3.401 1.26 2.172 0 3.684-1.513T14.187 9t-1.512-3.684Q11.163 3.804 8.99 3.804q-1.24 0-2.329.562a5.4 5.4 0 0 0-1.844 1.558h1.937V7.5H2.133V2.888h1.568v1.695a6.7 6.7 0 0 1 2.361-1.838 6.8 6.8 0 0 1 2.93-.647q1.432 0 2.69.545a7 7 0 0 1 2.189 1.478 7 7 0 0 1 1.477 2.189q.546 1.257.545 2.69 0 1.433-.545 2.69a7 7 0 0 1-1.477 2.19 7 7 0 0 1-2.19 1.477 6.7 6.7 0 0 1-2.69.546m2.078-3.717-2.85-2.85V5.25h1.567V8.7l2.387 2.382z" />
    </g>
  </svg>
)
export default SvgDeviceReset
